import CarHouseUsers from '../components/CarHouse/CarHouseUsers'

const Users = () => {
  return <CarHouseUsers />;
};

export default Users;
